import Point from '../lib/Cordinates/Point';
import settings from '../lib/_settings.js';
import * as PIXI from 'pixi.js';

export default class Screw extends PIXI.Sprite {
    constructor(type, color = null) { 
        let texture;
        if (type == "screw") {
            texture = PIXI.Texture.from("screw-black");
        } else if (type == "bolt") {
            texture = PIXI.Texture.from(type + '-' + color);
        }
         
        super(texture);

        this.type = type;   
        this.point = new Point();
        
        // PIXI props
        this.height = 30;
        this.width = 30;
        this.position.set(-settings.spriteOverlay / 2, -settings.spriteOverlay / 2);
    }

    changeTexture(type) {
        if (type == "screw") {
            this.texture = PIXI.Texture.from("screw-black");
        } else if (type == "bolt") {
            this.texture = PIXI.Texture.from(type + '-' + this.color);
        }
    }
}
